import React, { useState } from 'react';
import './LogInComponent.css';  // Reutilizamos el mismo archivo CSS
import { AddProfile } from '../Backend/ApiCalls';
import { Notification } from './NotificationLoginComponent'; 

export const AddUserComponent = (props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [showNotification, setShowNotification] = useState(false);
    const [isErrorNoti, setErrorNoti] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        const userId = document.getElementById('userId').value;
        const password = document.getElementById('password').value;
    
        // Simula la creación de un nuevo usuario basado en la entrada
        const newUser = {
            username: userId,
            password: password
        };
    
        // Obtén el usuario principal de localStorage
        const mainUser = JSON.parse(localStorage.getItem('mainUser'));
    
        console.log('mainUser:', mainUser);  // Verificar si se obtiene correctamente el mainUser
    
        if (mainUser && mainUser.id) {  // Verifica que 'mainUser' y su 'id' existen
            // Llama a la API para añadir el nuevo perfil
            const { response, data } = await AddProfile(mainUser.id, newUser.username);
            if (response.ok) {
                setErrorMessage(props.I18n.SuccessMessageUserAdded);  // Mensaje de éxito
                setErrorNoti(false);
    
                // Redirige al perfil después de añadir el usuario
                setTimeout(() => {
                    window.location.href = '/perfil';
                }, 3000);
            } else {
                setErrorMessage(props.I18n.ErrorMessageUserAdd);  // Mensaje de error si falla
                setErrorNoti(true);
            }
        } else {
            setErrorMessage(props.I18n.NoMainUserError);  // Error si no hay cuenta principal
            setErrorNoti(true);
            console.error("Error: mainUser o su id no se encontró en localStorage.");
        }
    
        setShowNotification(true);
        setTimeout(() => {
            setShowNotification(false);
        }, 5000);
    };
    

    return (
        <div className='login-content'>
            {showNotification && <Notification message={errorMessage} type={isErrorNoti ? "error" : "success"} />}
            <div id="iniciar-sesion">
                <h1>{props.I18n.AddUser}</h1>  {/* Cambiamos el título */}
                <form name="AddUserForm" onSubmit={handleSubmit}>
                    <div className="form__group field">
                        <input type="text" className="form__field login-input" placeholder="ID Fallero" name="userId" id="userId" required />
                        <label htmlFor="userId" className="form__label">{props.I18n.IDFallero}</label>
                    </div>

                    <div className="form__group field">
                        <input type="password" className="form__field login-input" placeholder="Contraseña" name="password" id="password" required />
                        <label htmlFor="password" className="form__label">{props.I18n.Password}</label>
                    </div>
                    <button id="add-user" className="log" type="submit">{props.I18n.AddUserButton}</button>  {/* Cambiamos el texto del botón */}
                </form>
            </div>
        </div>
    );
};
